import { pushEvent } from '../../client/data-layer';

const POLL_ID = 'user_sentiment';
const QUESTION_ID_RATING = 'user_sentiment_rating';

export const trackUserSentimentLoaded = () => {
  pushEvent('pollLoaded', {
    poll_id: POLL_ID,
  });
};

export const trackUserSentimentOpen = () => {
  pushEvent('pollOpened', {
    poll_id: POLL_ID,
  });
};

export const trackUserSentimentClose = () => {
  pushEvent('pollClosed', {
    poll_id: POLL_ID,
  });
};

export const trackUserSentimentRateOpened = () => {
  pushEvent('pollQuestionOpened', {
    question_id: QUESTION_ID_RATING,
    poll_id: POLL_ID,
  });
};

export const trackUserSentimentRate = (rating: number) => {
  pushEvent('pollQuestionCompleted', {
    value: rating,
    question_id: QUESTION_ID_RATING,
    poll_id: POLL_ID,
  });
};

export const trackUserSentimentCompleted = () => {
  pushEvent('pollCompleted', {
    poll_id: POLL_ID,
  });
};
